import axios from 'axios';


const httpClient = axios.create({
  //timeout: 10000, // 10 seconds timeout
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
  },
  //baseURL: 'https://stagingapi.ultronpms.com/', //staging
  //baseURL: 'https://developmentapi.ultronpms.com/', //development
  //baseURL: 'https://demoapi.ultronpms.com/', //demo
  baseURL: 'https://prodapi.ultronpms.com/', //production
  //baseURL: 'https://localhost:44372/', //developement-local
  
});

export default httpClient;